import { CommonModule } from '@angular/common';
import { Component, inject } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatInputModule } from '@angular/material/input';
import { ButtonDirective, SmataSingleInputComponent } from '@smata-shared';
import { AuthStore } from '../store/auth.store';
@Component({
  selector: 'smata-login',
  standalone: true,
  imports: [
    CommonModule,
    SmataSingleInputComponent,
    ButtonDirective,
    ReactiveFormsModule,
    MatInputModule,
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss',
})
export class SmataLoginComponent {
  private readonly authStore = inject(AuthStore);

  readonly formControl = {
    identifier: new FormControl('', [Validators.required]),
  };

  private readonly form = new FormGroup(this.formControl);

  onSubmit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    const identifier = this.form.getRawValue().identifier;
    if (!identifier) return;

    this.authStore.requestPasscode(identifier);
  }
}
